/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfileAssignment } from '../../models/student-profile-assignment';

export interface GetStudentAssignment$Params {
  profileId: string;
  id: string;
}

export function getStudentAssignment(http: HttpClient, rootUrl: string, params: GetStudentAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileAssignment>> {
  const rb = new RequestBuilder(rootUrl, getStudentAssignment.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfileAssignment>;
    })
  );
}

getStudentAssignment.PATH = '/studentprofile/{profileId}/assignment/{id}';
